module.exports = __webpack_public_path__ + "static/media/Logo__1517.5e514790.svg";